import React from "react";

const About = () => (
  <main>
    <div className="home-grid">
      <div className="main-header">
        <h1>About Me</h1>
      </div>
      <div className="home-text-container">
        
        <p>I have been drawn to computers and technology in general since even before my parents bought me a TRS-80 in the mid 1980's. Unfortunately, I never thought of it as a career option until after I was already committed to a career in law.</p>
        <p>Even while working in the legal field I was always staying up to date on any technology that could be leveraged to make our jobs easier. Wherever I worked, I quickly became the go-to "tech" person, serving on technology committees and working closely with the IT personnel.</p>
        <p>I would also become the de-facto webmaster, teaching myself HTML, CSS and other languages in my spare time. I would write scripts and my own programs to make the clunky case management software used at a firm do what I thought it already should have done, which was often more exciting and rewarding than the actual legal work.</p> 
        <p>A career spent fighting for a living takes its toll on a person and like so many others before me, the practice of law quickly lost its luster and eventually burned me out. </p>
        <p>I have long said that if I had it all to do over, I would have majored in Computer Science in college, so after the Covid-19 pandemic hit, I decided to make the career change I had been considering for years.</p>
        <p>During the pandemic, I completed a Full-Stack JavaScript bootcamp, taught myself additional programming skills and practiced by completing numerous projects. I have thoroughly enjoyed the journey and know that I made the right decision.</p>  
        <p>After a lifetime of interest and self-education in the area I have now fully committed to a career in software development.</p>
      </div>
    </div>
  </main>
);

export default About;
